<template>
  <div class="wspo-tour-wrapper" @click.self="setTour(null)">
    <div class="wspo-tour-content">
      <div class="wspo-tour-head">
        <div
          class="wspo-tour-wrapper-close wspo-icon"
          @click="setTour(null)"
        ></div>
        <div class="wspo-tour-hotel">
          <div class="wspo-tour-hotelname">{{ data.hotel.toLowerCase() }}</div>
          <div class="wspo-tour-rate">
            <div class="wspo-stars">
              <div
                v-for="star in parseInt(data.cat, 10)"
                :key="star"
                class="wspo-star wspo-icon"
              ></div>
            </div>
            <div class="wspo-tour-rating wspo-icon" v-if="rating > 0">
              {{ rating }}
            </div>
          </div>
        </div>
      </div>
      <div class="wspo-tour-main">
        <div class="wspo-tour-info">
          <div class="wspo-tour-info-row">
            <div class="wspo-tour-option wspo-tour-departurename wspo-icon">
              {{ data.city }}
            </div>
            <div class="wspo-tour-option wspo-tour-countryname wspo-icon">
              {{ data.country }}
            </div>
            <div class="wspo-tour-option wspo-tour-flydate wspo-icon">
              {{ data.date }}
            </div>
            <!-- <div
            v-if="data.visacharge"
            class="wspo-tour-option wspo-tour-visacharge wspo-icon"
          >
            <span>
              виза на чел:
              <br />
              <span v-html="currencyString(data.visacharge)"></span>
            </span>
            </div>-->
          </div>
          <div class="wspo-tour-info-row">
            <div class="wspo-tour-option wspo-tour-nights wspo-icon">
              {{ data.nights
              }}{{
                data.nights > 4
                  ? ' ночей'
                  : data.nights == 1
                  ? ' ночь'
                  : ' ночи'
              }}
            </div>
            <div class="wspo-tour-option wspo-tour-adults wspo-icon">
              2 взрослых
            </div>
            <div class="wspo-tour-option wspo-tour-meal wspo-icon">
              {{ data.feed }}
            </div>
          </div>
        </div>
        <div class="wspo-tour-action">
          <div class="wspo-tour-price">
            <div class="wspo-small">Цена за номер</div>
            <div class="wspo-price" v-html="currencyString(data.price)"></div>
          </div>
          <div class="wspo-button-main" @click="goToForm">Продолжить</div>
        </div>
      </div>

      <div class="wspo-tour-body">
        <div class="wspo-tour-media">
          <div class="wspo-tour-tabs">
            <div
              class="wspo-tour-tab wspo-button-second"
              :class="{ 'wspo-active': isSelectedTab('tour') }"
              @click="selectTab('tour')"
            >
              О туре
            </div>
            <div
              v-if="coords"
              class="wspo-tour-tab wspo-button-second"
              :class="{ 'wspo-active': isSelectedTab('map') }"
              @click="selectTab('map')"
            >
              На карте
            </div>
            <div
              v-if="lt"
              class="wspo-tour-tab wspo-button-second"
              :class="{ 'wspo-active': isSelectedTab('hotel') }"
              @click="selectTab('hotel')"
            >
              Об отеле
            </div>
          </div>
          <div class="wspo-tour-tabcontents">
            <div
              class="wspo-tour-tabcontent"
              :class="{ 'wspo-active': isSelectedTab('tour') }"
            >
              <Gallery :images="images" />
              <Includes :data="data" />
            </div>
            <div
              class="wspo-tour-tabcontent"
              :class="{ 'wspo-active': isSelectedTab('map') }"
            >
              <Map
                v-if="isSelectedTab('map') && coords"
                :latitude="parseFloat(coords[0])"
                :longitude="parseFloat(coords[1])"
                :countrycode="data.country === 'Россия' ? '47' : ''"
              />
            </div>
            <div
              class="wspo-tour-tabcontent"
              :class="{ 'wspo-active': isSelectedTab('hotel') }"
            >
              <Hotel v-if="lt" :data="data" />
            </div>
          </div>
        </div>
        <div class="wspo-tour-text">
          <Description :data="data" />
          <div v-if="sent" class="wspo-feedback-form is-sent">
            <div class="wspo-feedback-form-title">
              Спасибо за обращение, {{ feedback.username }}!
            </div>
            <div class="wspo-feedback-response">
              Наш менеджер свяжется с Вами в ближайшее время
            </div>
          </div>
          <Form v-else ref="form" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Gallery from '@/components/Gallery.vue';
import Includes from '@/components/Includes.vue';
import Description from '@/components/Description.vue';
import Map from '@/components/Map.vue';
import Hotel from '@/components/Hotel.vue';
import Form from '@/components/Form.vue';
import { mapMutations, mapState, mapGetters } from 'vuex';
export default {
  name: 'Tour',
  components: {
    Gallery,
    Includes,
    Form,
    Description,
    Map,
    Hotel
  },
  mounted() {
    document.body.style.overflow = document.documentElement.style.overflow =
      'hidden';
  },
  destroyed() {
    document.body.style.overflow = document.documentElement.style.overflow = '';
  },
  data() {
    return {
      tabSelected: 'tour'
    };
  },
  computed: {
    ...mapGetters(['currencyString']),
    ...mapState(['tour', 'tours', 'sent', 'feedback']),
    data() {
      return this.tours.find(t => t.id === this.tour) || null;
    },
    rating() {
      return this.data.lt_rate
        ? this.data.lt_rate
        : this.data.tv_rate
        ? this.data.tv_rate * 2
        : 0;
    },
    images() {
      return this.data.photo.map(p => `//well.ru${p}`);
    },
    isSelectedTab() {
      return tab => this.tabSelected === tab;
    },
    coords() {
      return parseFloat(this.data.tv_coord1) > 0
        ? [this.data.tv_coord1, this.data.tv_coord2]
        : false;
    },
    lt() {
      return this.data.lt_short_info;
    }
  },
  methods: {
    ...mapMutations(['setTour']),
    goToForm() {
      // console.log(this.$refs.form);
      this.$refs.form.$el.scrollIntoView({ behavior: 'smooth' });
    },
    selectTab(tab) {
      this.tabSelected = tab;
    }
  }
};
</script>

<style scoped>
.wspo-tour-wrapper {
  z-index: 9000;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 50px 0;
  background-color: var(--color-text-5);
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: auto;
}
.wspo-tour-head {
  margin: 8px 18px;
  display: flex;
}
.wspo-tour-wrapper-close {
  position: absolute;
  left: unset;
  top: 0;
  right: 0;
  cursor: pointer;
  padding: 8px 12px;
  background-color: var(--color-bg);
}
.wspo-tour-wrapper-close:before {
  width: 100%;
  content: '\f00d';
  text-align: center;
  color: var(--color-main);
  font-size: 18px;
}
@media (max-width: 575px) {
  .wspo-tour-wrapper-close {
    position: fixed;
    z-index: 9999;
    top: 8px;
    right: 28px;
  }
}
.wspo-tour-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  width: 100%;
  max-width: 1200px;
  border-radius: 4px;
  background-color: var(--color-paper);
  min-height: 60vh;
  position: relative;
}
.wspo-tour-hotel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wspo-tour-hotelname {
  font-size: 22px;
  text-transform: capitalize;
}

/* stars */
.wspo-stars {
  display: flex;
  align-items: center;
  margin-right: 8px;
  margin-left: 8px;
}
.wspo-star,
.wspo-star-unchecked {
  margin-right: 2px;
  cursor: pointer;
}
.wspo-star-unchecked:before,
.wspo-star:before {
  content: '\f005';
  font-size: 14px;
}
.wspo-star:before {
  color: var(--color-third);
}
.wspo-star-unchecked:before {
  color: var(--color-alt-5);
}

/* rating */
.wspo-tour-rate {
  display: flex;
  padding-top: 4px;
}
.wspo-tour-rating {
  background-color: var(--color-bg);
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 12px;
  font-size: 16px;
}
.wspo-tour-rating:before {
  content: '\f581';
  color: var(--color-alt);
  margin-right: 8px;
  font-size: 18px;
}

/* body */
.wspo-tour-body {
  display: flex;
  flex-wrap: wrap;

  background-color: var(--color-bg-dark);
}
.wspo-tour-media {
  flex: 3 0 800px;
  max-width: 100%;
}
.wspo-tour-text {
  flex: 1 0 400px;
  height: 600px;
  overflow: auto;
  max-width: 100%;
  background-color: var(--color-bg);
}
@media (max-width: 1000px) {
  .wspo-tour-text {
    height: unset;
  }
}

/* tour info */
.wspo-tour-main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 4px 0;
}
.wspo-tour-info {
  flex: 2;
  padding: 8px 18px;
}
.wspo-tour-info-row {
  padding: 8px 0 0;
  border-top: 1px solid var(--color-alt-5);
  display: flex;
  flex-wrap: wrap;
}
.wspo-tour-info-row:first-child {
  border: none;
}
.wspo-tour-action {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  padding: 8px 18px;
  min-width: 300px;
}
.wspo-tour-price {
  flex: 1;
}
.wspo-tour-fuelcharge {
  flex: 1;
}
.wspo-tour-option {
  flex: 1 0 100px;
  margin-right: 8px;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
}
.wspo-tour-option:before {
  font-size: 18px;
  margin-right: 8px;
  width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-alt-5);
}
.wspo-tour-departurename:before {
  content: '\f5b0';
}
.wspo-tour-countryname:before {
  content: '\f5af';
}
.wspo-tour-hotelregionname:before {
  content: '\f3c5';
}
.wspo-tour-adults:before {
  content: '\f500';
}
.wspo-tour-flydate:before {
  content: '\f783';
}
.wspo-tour-visacharge:before {
  content: '\f2c2';
}
.wspo-tour-nights:before {
  content: '\f186';
}
.wspo-tour-meal:before {
  content: '\f725';
}

/* tabs */
.wspo-tour-tabs {
  display: flex;
  height: 43px;
  background-color: var(--color-paper);
}
.wspo-tour-tab {
  border-radius: 0;
  margin-top: 4px;
}
.wspo-tour-tab.wspo-active {
  background-color: var(--color-paper);
  border-top: 8px solid var(--color-alt-5);
  margin-top: 0;
  border-bottom: 0;
  padding-top: 0;
}
.wspo-tour-tabcontent {
  display: none;
  min-height: 557px;
}
.wspo-tour-tabcontent.wspo-active {
  display: flex;
  flex-direction: column;
}
@media (max-width: 1000px) {
  .wspo-tour-tabcontent {
    min-height: unset;
  }
}

/* response */
.wspo-feedback-form {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;
  flex-wrap: wrap;
  padding: 32px 24px;
  background-color: var(--color-bg);
  flex: 1 1 300px;
}
.wspo-feedback-form-title {
  font-size: 18px;
  padding: 0 8px 8px;
  width: 100%;
  text-align: center;
}
.wspo-feedback-response {
  padding: 12px 8px;
  text-align: center;
}
</style>
